import { createClient } from '@supabase/supabase-js';

// ── Backend switch ──────────────────────────────────────────────────────────
// Defaults to PRODUCTION so any deployed build is unaffected. For local DEV
// testing against onthemoov-dev, run:  REACT_APP_ACTIVE_ENV=development npm start
const ENV = process.env.REACT_APP_ACTIVE_ENV || 'production';
const BACKENDS = {
  production: {
    url: 'https://dmnsynbxftuqmubdnhgw.supabase.co',
    anon: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRtbnN5bmJ4ZnR1cW11YmRuaGd3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzMDgyMTMsImV4cCI6MjA3NTg4NDIxM30.9AgTlIKIoh-1Kt8BqTZWxsnav4WuWhpQF0i_JBVzLgo',
  },
  development: {
    url: 'https://trxnjwawedkbdfcsezrb.supabase.co',
    anon: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRyeG5qd2F3ZWRrYmRmY3NlenJiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQwMTM3MTEsImV4cCI6MjA5OTU4OTcxMX0.nZ7VR_sRTDZr4HFQdmjfmKUcA5Tc6yHvQPREJepCXY4',
  },
};
const { url: supabaseUrl, anon: supabaseAnonKey } = BACKENDS[ENV] || BACKENDS.production;
console.log('🔧 Packer backend:', ENV, '→', supabaseUrl);

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false
  }
});
